import React from "react";

interface PlaceholderPageProps {
  title: string;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ title }) => {
  return (
    <div className="min-h-screen p-8 bg-base-100">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-base-content">{title}</h1>
        <div className="bg-base-200 p-6 rounded-lg shadow-md">
          <p className="text-8xl text-base-content/70 text-center leading-[1.5] text-justify">
            <strong className="text-primary">{title}</strong> content still
            waiting from{" "}
            <strong className="text-primary">DIVHUBINTER POLRI</strong>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderPage;
